var React = require('react');

function LongArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.5303 6.53033C40.8232 6.23744 40.8232 5.76256 40.5303 5.46967L35.7574 0.696699C35.4645 0.403806 34.9896 0.403806 34.6967 0.696699C34.4038 0.989593 34.4038 1.46447 34.6967 1.75736L38.9393 6L34.6967 10.2426C34.4038 10.5355 34.4038 11.0104 34.6967 11.3033C34.9896 11.5962 35.4645 11.5962 35.7574 11.3033L40.5303 6.53033ZM0 6.75H40V5.25H0V6.75Z","fill":"white"}));
}

LongArrow.defaultProps = {"width":"41","height":"12","viewBox":"0 0 41 12","fill":"none"};

module.exports = LongArrow;

LongArrow.default = LongArrow;
